import { render, staticRenderFns } from "./EditarContatoDialog.vue?vue&type=template&id=1d42217f&scoped=true"
import script from "./EditarContatoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarContatoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditarContatoDialog.vue?vue&type=style&index=0&id=1d42217f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d42217f",
  null
  
)

export default component.exports